import { queryRole } from '@/api/role'
import * as T from '@/core/configs/types'
import get from 'lodash/get'

export const RemeberMeKey = 'remember_username'
export const RememberedUsername = 'remembered_username'

export function getIsRememberUsername() {
  const flag = localStorage.getItem(RemeberMeKey)
  return flag === 'true'
}

export function setIsRememberUsername(flag) {
  localStorage.setItem(RemeberMeKey, flag)
}

export function getRememberedUsername() {
  return localStorage.getItem(RememberedUsername)
}

export function removeRememberedUsername() {
  localStorage.removeItem(RememberedUsername)
}

export function setRememberedUsername(uesrname) {
  return localStorage.setItem(RememberedUsername, uesrname)
}

export const User = {
  id: {
    type: T.String,
    label: 'ID',
    key: 'id'
  },
  clientId: {
    type: T.String,
    label: 'Client',
    key: 'clientId'
  },
  username: {
    type: T.String,
    label: 'Username',
    key: 'username'
  },
  password: {
    type: T.String,
    label: 'Password',
    key: 'password'
  },
  nickname: {
    type: T.String,
    label: 'Nickname',
    key: 'nickname'
  },
  phone: {
    type: T.String,
    label: 'Phone',
    key: 'phone'
  },
  email: {
    type: T.String,
    label: 'Email',
    key: 'email'
  },
  status: {
    type: T.Enum,
    label: 'Status',
    key: 'status',
    options: Object.values(T.StatusTypes)
  },
  source: {
    type: T.String,
    label: 'Source',
    key: 'source'
  },
  icon: {
    type: T.String,
    label: 'Icon',
    key: 'icon'
  },
  gender: {
    type: T.Enum,
    label: 'Gender',
    key: 'gender',
    options: Object.values(T.GenderTypes)
  },
  city: {
    type: T.String,
    label: 'City',
    key: 'city'
  },
  type: {
    type: T.Number,
    label: 'Type',
    key: 'type'
  },
  createdTime: {
    type: T.Time,
    label: 'Created on',
    key: 'createdTime'
  },
  updatedTime: {
    type: T.Time,
    label: 'Updated on',
    key: 'updatedTime'
  }
}

export const UserTableHeaders = [
  { ...User.username, width: 140 },
  { ...User.nickname, width: 100 },
  { ...User.clientId, width: 100 },
  { ...User.email, width: 150 },
  {
    ...User.status,
    type: T.Tag,
    effect: 'plain',
    tagType: 'primary',
    width: 60
  },
  {
    type: T.String,
    label: 'Role',
    key: 'role.name'
  },
  { ...User.createdTime, width: 100 }
]

export const UserSearchForm = Object.fromEntries(
  [
    {
      ...User.username,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      ...User.clientId,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      ...User.email,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      ...User.phone,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      ...User.source,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      ...User.status,
      key: 'statusList',
      multiple: true,
      type: T.Select,
      options: [...User.status.options],
      value: [],
      validators: [T.RequiredNotEmptyListValidator],
      convertor: T.DefaultConvertor
    },
    ...T.PaginationSearchForm
  ].map(one => [one.key, one])
)

export const UserForm = Object.fromEntries(
  [
    {
      ...User.email,
      type: T.TextInput,
      span: 1,
      example: '',
      default: 'it@riiexpress.com',
      value: '',
      validators: []
    },
    {
      ...User.status,
      type: T.Select,
      example: '',
      default: T.StatusValid,
      value: '',
      validators: [],
      convertor: value => value
    },
    {
      ...User.username,
      type: T.TextInput,
      span: 1,
      example: '张三',
      default: 'IT',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...User.nickname,
      type: T.TextInput,
      span: 1,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...User.password,
      type: T.TextInput,
      span: 1,
      example: '123456',
      default: 'riisystem!!',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      label: 'Password Confirm',
      key: 'passwordConfirm',
      type: T.TextInput,
      span: 1,
      example: '123456',
      default: 'riisystem!!',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      key: 'blankOne',
      type: T.Blank,
      span: 1,
      example: '123456',
      default: '',
      value: '',
      validators: []
    },
    {
      ...User.city,
      type: T.TextInput,
      span: 1,
      example: '',
      default: 'LA',
      value: '',
      validators: []
    },
    {
      type: T.RemoteSelect,
      label: 'Role',
      key: 'roleId',
      span: 2,
      example: '',
      options: [],
      default: '',
      value: '',
      method: function (name) {
        const that = this
        this.loading = true
        queryRole({ name, size: -1 }).then(res => {
          that.loading = false
          that.options = res.records.map(one => ({
            key: one.id,
            label: one.name,
            value: one.id
          }))
        })
      },
      validators: []
    }
  ].map(one => [one.key, one])
)

export const InitUserForm = function (inputs) {
  return Object.keys(UserForm).map(key => {
    const one = {
      ...UserForm[key],
      value: get(inputs, key, UserForm[key].default)
    }
    return one
  })
}

export const UserSearchParamsWrapUp = searchForm => {
  const params = {}
  Object.keys(searchForm).forEach(key => {
    if (searchForm[key].value !== T.All) {
      params[key] = searchForm[key].value
    }
  })
  return params
}

export const UserCreateCheck = userInfo => {
  const errMsgs = []
  // check password
  if (userInfo.password !== userInfo.passwordConfirm) {
    errMsgs.push('Password must be the same!')
  }
  if (!userInfo.email.endsWith('@riiexpress.com')) {
    errMsgs.push('Email is not a valid riiexpress email!')
  }
  if (!userInfo.roleId) {
    errMsgs.push('Role is not assigned!')
  }
  return { passed: true, errMsgs }
}

const UserBasicInfoPicks = [
  { ...UserForm.username, type: T.Text, span: 1 },
  { ...UserForm.nickname, type: T.Text, span: 1 },
  { ...UserForm.email, type: T.Text, span: 1 },
  { ...UserForm.status, type: T.Text, span: 1 },
  { ...UserForm.city, type: T.Text, span: 1 }
]

export const UserBasicInfoWrapUp = T.generateWrapUp(UserBasicInfoPicks)

export const UserBasicInfoModifyForm = Object.fromEntries(
  [
    {
      ...User.username,
      span: 1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...User.nickname,
      span: 1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...User.gender,
      span: 1,
      type: T.Select,
      example: 'Created',
      default: T.MaleGender,
      value: T.MaleGender,
      validators: [T.RequiredValidator]
    },
    {
      ...User.city,
      span: 1,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    }
  ].map(one => [one.key, one])
)
